export type SetCookieOptions = {
    domain?: string;
    expires?: Date;
    path?: string;
    secure?: boolean;
};

export type SetCookieValue = boolean | number | string;

export function createSetCookieString(
    cookieName: string,
    value: SetCookieValue,
    options: SetCookieOptions = {},
): string {
    const sanitizedName = encodeURIComponent(cookieName);
    const sanitizedValue = encodeURIComponent(value);

    const optionsArray: string[] = [];

    if (options.domain) {
        optionsArray.push(`domain=${encodeURIComponent(options.domain)}`);
    }
    if (options.expires) {
        optionsArray.push(`expires=${options.expires.toUTCString()}`);
    }
    if (options.path) {
        optionsArray.push(`path=${options.path}`);
    }
    if (options.secure) {
        optionsArray.push('secure');
    }

    return [`${sanitizedName}=${sanitizedValue}`, ...optionsArray].join('; ');
}
